export default __webpack_public_path__ + "static/cookie-965b6d1ba8d7e298bc874f06b33c7c7a.png";